export default __webpack_public_path__ + "static/images/in.4274c89a.png";